module.exports = __webpack_public_path__ + "img/LoadScreen.4585a773.png";